import React from 'react';
import { AuthLayout } from '../../components/layout/AuthLayout';
import { OtpForm } from '../../features/auth/OtpForm';

export const OtpPage = () => {
  return (
    <AuthLayout>
      <OtpForm />
    </AuthLayout>
  );
};
